module.exports = __webpack_public_path__ + "static/media/front.5e77e244.jpg";